<template>
  <div>
    <CRow>
      <CCol sm="12" md="12">
        <CCard accent-color="primary">
          <CCardHeader
            class="font-weight-bold padding-sm align-items-center text-sm d-flex justify-content-between catalogo-text"
          >
            {{folio?'Editar':'Registrar'}} gasto {{folio?`Folio:${folio}`:''}}
            <router-link :to="{ name: 'Gasto' , params: { config: config } }">
              <CButton color="primary" class="mr-1 btn-header">
                <CIcon class="mr-1" name="cil-arrow-thick-left" />Regresar
              </CButton>
            </router-link>
          </CCardHeader>

          <CCardBody>
            <CRow>
              <CCol sm="12" md="9" lg="9">
                <label>Fecha:</label>
                <CInput
                  :value.sync="$v.date.$model"
                  :isValid="checkIfValid('date')"
                  type="date"
                  :horizontal="{ input: 'col-sm-12' }"
                  invalidFeedback="Campo requerido"
                />
              </CCol>
            </CRow>
            <CRow>
              <CCol md="9" lg="9" xl="9">
                <label>Empresa:</label>
                <v-select
                  v-model="empresa"
                  :options="empresas"
                  :loading="isLoadingPage"
                  class="margin-multi"
                  placeholder="Empresa"
                >
                  <template #open-indicator="{ attributes }">
                    <CIcon v-bind="attributes" class="cursor-p" name="cil-caret-bottom" />
                  </template>
                  <template #no-options>Sin resultados.</template>
                </v-select>
              </CCol>
            </CRow>

            <CRow>
              <CCol sm="12" md="9" lg="9">
                <label>Ubicaciones:</label>
                <div class="d-flex margin-multi align-items-center">
                  <multiselect
                    v-model="multi"
                    :options="ubicaciones"
                    :multiple="true"
                    :loading="isLoadingPage"
                    label="label"
                    track-by="label"
                    placeholder="Selecciona uno o varias ubicaciones"
                    :close-on-select="false"
                    :clear-on-select="false"
                  >
                    <template #no-options>Sin resultados.</template>
                  </multiselect>
                  <transition name="fade">
                    <div v-show="multi && multi.length" @click="cleanMulti()">
                      <CIcon size="lg" class="ml-2 cursor-p" name="cil-trash" />
                    </div>
                  </transition>
                </div>
              </CCol>
            </CRow>

            <CRow>
              <CCol md="9" lg="9" xl="9">
                <label>Gasto:</label>
                <v-select
                  v-model="servicio"
                  :options="servicios"
                  :loading="isLoadingPage"
                  class="margin-multi"
                  placeholder="Gasto"
                >
                  <template #open-indicator="{ attributes }">
                    <CIcon v-bind="attributes" class="cursor-p" name="cil-caret-bottom" />
                  </template>
                  <template #no-options>Sin resultados.</template>
                </v-select>
              </CCol>
            </CRow>


            <CRow>
              <CCol sm="12" md="9" lg="9">
                <CInput
                  v-model="folio_factura"
                  label="Folio Factura"
                  placeholder="Folio Factura..."
                  type="text"
                />
              </CCol>
            </CRow>

            <CRow>
              <CCol md="12" lg="9" xl="9">
                <label>Costo unitario:</label>
                <CInput
                  :value.sync="$v.costo.$model"
                  :isValid="checkIfValid('costo')"
                  placeholder="Costo unitario"
                  type="number"
                  invalidFeedback="Campo requerido"
                />
              </CCol>
            </CRow>
            <CRow>
              <CCol md="9" lg="9" xl="9">
                <label>Proveedor:</label>
                <v-select
                  v-model="proveedor"
                  :options="proveedores"
                  :loading="isLoadingPage"
                  class="margin-multi"
                  placeholder="Proveedor"
                >
                  <template #open-indicator="{ attributes }">
                    <CIcon v-bind="attributes" class="cursor-p" name="cil-caret-bottom" />
                  </template>
                  <template #no-options>Sin resultados.</template>
                </v-select>
              </CCol>
            </CRow>

            <CRow>
              <CCol sm="12" md="9" lg="9">
                <CTextarea
                  :value.sync="comentarios"
                  :label="`Comentarios: `"
                  placeholder="Comentarios..."
                />
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="12" md="9" lg="9">
                <KlayFileDD
                  :fetching="fetching"
                  v-model="medias"
                  :label="`Anexos: `"
                  @onFetch="()=>{fetching=false}"
                  @onErrorFetch="(err)=>{
                    fetching=false;
                    error=err
                    warningModal=true
                  }"
                  :fetchMethod="pushMedia"
                  :baseSrc="$store.getters.MediaGet"
                />
              </CCol>
            </CRow>
            <div class="mask-edit" v-if="folio&&isLoadingPage">
              <div class="w-100 d-flex justify-content-center align-items-center">
                <div class="sk-flow flex align-items-center">
                  <div class="sk-flow-dot bg-load-blue"></div>
                  <div class="sk-flow-dot bg-load-blue"></div>
                  <div class="sk-flow-dot bg-load-blue"></div>
                </div>
              </div>
            </div>
          </CCardBody>
          <CCardFooter class="d-flex justify-content-center">
            <router-link :to="{ name: 'Gasto', params: { config: config }  }">
              <CButton class="px-4 mx-3 btn-lg" color="danger">Cancelar</CButton>
            </router-link>

            <CButton v-if="isLoading" class="px-4 mx-3 btn-lg" color="success">
              <div>
                <div class="w-100 d-flex justify-content-center align-items-center">
                  <div class="sk-flow height-custom flex align-items-center">
                    <div class="sk-flow-dot bg-load-white"></div>
                    <div class="sk-flow-dot bg-load-white"></div>
                    <div class="sk-flow-dot bg-load-white"></div>
                  </div>
                </div>
              </div>
            </CButton>
            <CButton v-else @click="addSalida()" class="px-4 mx-3 btn-lg" color="success">
              <span>Guardar</span>
            </CButton>
          </CCardFooter>
        </CCard>
      </CCol>

      <CModal
        size="sm"
        title="Gasto"
        :centered="true"
        color="warning"
        :show.sync="warningModal"
      >{{ error }}</CModal>
      <CModal
        size="sm"
        title="Gasto"
        :centered="true"
        color="success"
        :show.sync="successModal"
        >Guardado con éxito.
        <template #footer>
          <CButton @click="closeModal"  color="success">Aceptar</CButton>
        </template>
      </CModal>
    </CRow>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import moment from "moment";

const fieldsSecondModal = [
  { key: "servicio_id", _style: "width:20%" },
  { key: "cantidad", _style: "width:20%" },
  { key: "costo", _style: "width:20%" },
  { key: "importe", _style: "width:20%" },
  {
    key: "cancel",
    label: "",
    _style: "width:1%",
    sorter: false,
    filter: false
  }
];

export default {
  name: "NuevoGasto",

  components: {
    Multiselect,
    vSelect
  },

  data() {
    return {
      folio: this.$route.params.folio,
      item: null,
      nanoid: null,
      multi: null,
      config: this.$route.params.config,
      ubicaciones: [],
      ubicacionesAll: [],
      detalles: [],
      date: null,
      almacen: "",
      almacenes: [],
      unidad: "Unidad",
      fieldsSecondModal,
      folio_factura: '',
      servicios: [],
      empresas: [],
      proveedores: [],
      servicio: null,
      proveedor: null,
      empresa: null,
      serviciosAll: [],
      cantidad: null,
      isLoading: false,
      isLoadingPage: false,
      currentAlertCounter: 0,
      warningModal: false,
      successModal: false,
      error: "",
      costo: null,
      comentarios: '',
      fetching: false,
      medias:[],
    };
  },

  mixins: [validationMixin],
  validations: {
    date: {
      required
    },
    costo: {
      required,
      notNegative: (value) => value >= 0
    }
  },

  computed: {
    isValidDate() {
      return !this.$v.date.$invalid;
    },
    isValidCosto() {
      return !this.$v.costo.$invalid;
    },
    ubicacionRaiz() {
      return this.$store.state.rootLocation;
    },
    ubicacionRaizValue() {
      return this.$store.state.rootLocation
        ? this.$store.state.rootLocation.value
        : "";
    }
  },

  watch: {
    ubicacionRaiz: function() {
      this.updateCombos();
    }
  },

  created() {
    this.$store.dispatch('getNanoid');
    const ubicacionTemplateRaiz = this.$store.dispatch("customHTTP", {
      schema: "ubicaciones",
      filter: {
        where: [
          {
            field: "payload->raiz_id",
            value: this.ubicacionRaizValue,
            operator: "="
          },
          {
            field: "payload->suspendido",
            value: false,
            operator: "="
          }
        ]
      },
      order:[{
        field: 'payload->nombre',
        direction: 'asc'
      }]
    });
    const ubicacionTemplateNoRaiz = this.$store.dispatch("customHTTP", {
      schema: "ubicaciones",
      filter: {
        where: [
          {
            field: "payload->suspendido",
            value: false,
            operator: "="
          }
        ]
      },
      order:[{
        field: 'payload->nombre',
        direction: 'asc'
      }]
    });
    this.isLoadingPage = true;
    this.$store;

    const ubi = [
      this.$store.dispatch("customHTTP", {
        schema: "servicios",
        filter: {
          where: [
            {
              field: "payload->pertenece_id",
              value: 0,
              operator: "!="
            }
          ]
        }
      }),
      this.ubicacionRaizValue
      ?ubicacionTemplateRaiz
      :ubicacionTemplateNoRaiz,
      this.$store.dispatch("customHTTP", {
        schema: "proveedores",
      }),
      this.$store.dispatch("customHTTP", {
        schema: "empresas",
      }),
    ];
    if(this.folio){
      ubi.push(this.$store.dispatch("customDocumentoHTTP", {
        schema: "gastos",
        filter: {
          wherein: [
            {
              field: "payload->encabezado->ubicacion_raiz_id",
              value: [this.ubicacionRaizValue]
            }
          ],
          where: [
            {
              field: "folio",
              value: this.folio,
              operator: "="
            }
          ]
        },
        ["with-storage"] : ["*"]
      }))
    }
    Promise.all(ubi)
      .then(([servicios, ubicaciones, proveedores, empresas,item]) => {
        const pertenece_ids = servicios.data.map(m=>m.payload.pertenece_id);
        this.servicios = servicios.data.map(servicio => {
          return { value: servicio.id, label: servicio.payload.ruta_nombre, pertenece_id:servicio.payload.pertenece_id };
        }).filter(ff=>!pertenece_ids.includes(ff.value));

        this.proveedores = proveedores.data.map(proveedor => {
          return { value: proveedor.id, label: proveedor.payload.nombre };
        });
        this.empresas = empresas.data.map(empresa => {
          return { value: empresa.id, label: empresa.payload.nombre };
        });
        this.ubicaciones = ubicaciones.data.map(ubicacion => {
          return { value: ubicacion.id, label: ubicacion.payload.nombre };
        });
        this.serviciosAll = servicios.data;
        this.ubicacionesAll = ubicaciones.data;

        if(item){
          this.item = item.data[0]
          const newMult = this.item.payload.encabezado._relaciones.ubicacion
              .filter(ubi => ubi.id)
              .map(ubicacion => {
                return { value: ubicacion.id, label: ubicacion.payload.nombre };
              });
          this.multi = newMult;

          this.servicio = this.servicios.find(f=>f.value == this.item.payload.encabezado.servicio_id);
          this.proveedor = this.proveedores.find(f=>f.value == this.item.payload.encabezado.proveedor_id);
          this.empresa = this.empresas.find(f=>f.value == this.item.payload.encabezado.empresa_id);
          this.costo = this.item.payload.encabezado.costo;
          this.folio_factura = this.item.payload.encabezado?.folio_factura||'';
          this.comentarios = this.item.payload.encabezado.comentarios;
          this.medias = this.item.payload.anexos;
          this.nanoid = this.item.payload.encabezado.nanoid;

          this.date = moment(this.item.payload.encabezado.fechahora,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD')
          }
      })
      .finally(() => (this.isLoadingPage = false));
  },

  methods: {
    closeModal(){
      this.successModal = false;
      if(this.folio){
        this.$router.push({ name: 'Gasto' });
      }
    },
    async pushMedia(files) {
      const arr = [];

      for (const v of files.map(async (m) => {
        // eslint-disable-next-line no-extra-boolean-cast
        if(!!m.media){
          return Promise.resolve({data:m,status:"success"})
        }
        const formData = new FormData();
        formData.append("media", m);
        const promise = await this.$store.dispatch("customImageHTTP", formData);

        return promise;
      })) {
        const media = await v;

        if (media.status === "success") {
          arr.push(media.data);
        }
      }
      return arr;
      /*
        const formData = new FormData()
        formData.append('media', format.dataURLtoFile(this.fileList[0].thumbUrl))
        this.$store.dispatch('MEDIA_CARGAR', formData)
      */
    },
    async addSalida() {
      this.validateGasto();
      this.fetching = true
      this.isLoading = true;
      await (new Promise((res,)=>{
        const iter = setInterval(()=>{
          if(!this.fetching){
            this.error = ""
            clearInterval(iter)
            res()
          }
        },1000)
      }))
      this.isLoading = false;
      if(this.error){
        this.successModal = false;
        return
      }

      if (this.isValidDate && this.isValidCosto) {
        if (!this.servicio) {
          this.error = "El campo servicio es obligatorio";
          this.warningModal = true;
          return;
        }

        this.isLoading = true;
        let newDate = moment(this.date, "YYYY-MM-DD HH:mm:ss");
        this.multi ? "" : (this.multi = []);
        let valueUbicaciones = this.multi.map(item => item.value);

        this.$store
          .dispatch(this.folio?"customDocumentoRemplazarHTTP":"customDocumentoAddHTTP", {
            folio:this.folio,
            schema: "gastos",
            payload: {
              encabezado: {
                ...this.folio?{nanoid: this.nanoid}:{},
                fechahora: newDate.format("YYYY-MM-DD HH:mm:ss"),
                servicio_id: this.servicio ? this.servicio.value : "",
                proveedor_id: this.proveedor ? this.proveedor.value : "",
                empresa_id: this.empresa ? this.empresa.value : "",
                folio_factura: this.folio_factura||'',
                ubicaciones: valueUbicaciones,
                costo: Number(this.costo),
                ubicacion_raiz_id: this.ubicacionRaiz
                  ? this.ubicacionRaiz.value
                  : null,
                comentarios: this.comentarios || '',
              },
              anexos: this.medias,
            }
          })
          .then(() => {
            this.currentAlertCounter = 6;
            // this.$router.push({ name: "Gasto" });
          })
          .catch(rej => {
            // console.log(rej);
            this.error = rej.message;
            this.warningModal = true;
            this.isLoading = false;
            return;
          })

          .finally(() => {
            this.isLoading = false;
            if (!this.warningModal) {
              this.successModal = true;
            }
          });
      }
    },
    checkIfValid(fieldName) {
      const field = this.$v[fieldName];
      if (!field.$dirty) {
        return null;
      }
      return !(field.$invalid || field.$model === "");
    },
    validateGasto() {
      this.$v.date.$touch();
      this.$v.costo.$touch();
      // this.$v.equivalencia_6oz.$touch();
    },
    updateCombos() {
      const ubicacionTemplateRaiz = this.$store.dispatch("customHTTP", {
        schema: "ubicaciones",
        filter: {
          where: [
            {
              field: "payload->raiz_id",
              value: this.ubicacionRaizValue,
              operator: "="
            },
            {
              field: "payload->suspendido",
              value: false,
              operator: "="
            }
          ]
        },
        order:[{
          field: 'payload->nombre',
          direction: 'asc'
        }]
      });
      const ubicacionTemplateNoRaiz = this.$store.dispatch("customHTTP", {
        schema: "ubicaciones",
        filter: {
          where: [
            {
              field: "payload->suspendido",
              value: false,
              operator: "="
            }
          ]
        },
        order:[{
          field: 'payload->nombre',
          direction: 'asc'
        }]
      });
      this.isLoadingPage = true;
      this.$store;

      const ubi = [];

      if (this.ubicacionRaizValue) {
        ubi.push(ubicacionTemplateRaiz);
      } else {
        ubi.push(ubicacionTemplateNoRaiz);
      }

      Promise.all(ubi)
        .then(([ubicaciones]) => {
          this.ubicaciones = ubicaciones.data.map(ubicacion => {
            return { value: ubicacion.id, label: ubicacion.payload.nombre };
          });

          this.ubicacionesAll = ubicaciones.data;
        })
        .finally(() => (this.isLoadingPage = false));
    },
    cleanMulti() {
      this.multi = [];
    }
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="spinkit/spinkit.min.css"></style>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.catalogo-text {
  font-size: 1.2rem !important;
}
.line {
  color: #321fdb; /* old IE */
  background-color: #321fdb; /* Modern Browsers */
}
.margin-multi {
  margin-bottom: 1rem !important;
}
.bg-load-white {
  background-color: white !important;
}
.height-custom {
  height: 25px;
}
.cursor-p {
  cursor: pointer;
}
@media (max-width: 420px) {
  .btn-header {
    padding-left: 8px;
    padding-right: 8px;
    font-size: 11px;
  }
  .padding-sm {
    padding-left: 8px;
    padding-right: 8px;
  }
  .text-sm {
    font-size: 16px !important;
  }
  .margin-sm {
    margin: 5px;
  }
}
</style>
